import FormDietsContainer from './components/formComponents/FormDiets.container';

const Form = ({
  match,
  location,
  fetchDiets,
  fetchAllergens,
  fetchIngredientCategories,
  fetchIngredients,
  t,
  classes,
  brandConfig,
  diets,
  history,
}) => (
  <FormDietsContainer
    match={match}
    location={location}
    fetchDiets={fetchDiets}
    fetchAllergens={fetchAllergens}
    fetchIngredientCategories={fetchIngredientCategories}
    fetchIngredients={fetchIngredients}
    t={t}
    classes={classes}
    brandConfig={brandConfig}
    diets={diets}
    history={history}
  />
);

export default Form;
